import { API } from "aws-amplify";
import { GRAPHQL_AUTH_MODE } from "@aws-amplify/api";
import { GraphQLResult } from "@aws-amplify/api-graphql";
import { toast } from "react-toastify";
import { ILightsStatus } from "../../types/api";

/**
 * What the lights integration believes each indoor court should be, and what
 * Novemberbolaget reports it is. The call reaches their API, so it takes a
 * second or two - the caller should show that it is working.
 */
export const getLightsStatus = async (): Promise<ILightsStatus | null> => {
  const query = `
    query getLightsStatus {
      getLightsStatus {
        ... on LightsStatus {
          checked_at
          slot_time
          connection_ok
          test_court_name
          test_court_actual
          courts {
            court_id
            court_name
            slot_start
            slot_end
            expected
            actual
            in_sync
          }
        }
        ... on Error {
          message
        }
      }
    }
  `;
  try {
    const res = (await API.graphql({
      query,
      authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
    })) as GraphQLResult<any>;
    const response = res.data.getLightsStatus;
    if (!response || "message" in response) {
      toast.error(response?.message ?? "Kunde inte hämta ljusstatus");
      return null;
    }
    return response as ILightsStatus;
  } catch (error: any) {
    error.errors ? toast.error(error.errors[0].message) : toast.error(error);
    return null;
  }
};

export interface ILightsTestResult {
  test_court_name: string;
  before: boolean | null;
  after: boolean | null;
  ok: boolean;
}

/**
 * Flip the test court and read it back, proving the link works in both
 * directions. Touches Bana_99 only - never a real court.
 */
export const testLightsConnection =
  async (): Promise<ILightsTestResult | null> => {
    const query = `
    mutation testLightsConnection {
      testLightsConnection {
        ... on LightsTestResult {
          test_court_name
          before
          after
          ok
        }
        ... on Error {
          message
        }
      }
    }
  `;
    try {
      const res = (await API.graphql({
        query,
        authMode: GRAPHQL_AUTH_MODE.AWS_IAM,
      })) as GraphQLResult<any>;
      const response = res.data.testLightsConnection;
      if (!response || "message" in response) {
        toast.error(response?.message ?? "Kunde inte testa anslutningen");
        return null;
      }
      return response as ILightsTestResult;
    } catch (error: any) {
      error.errors ? toast.error(error.errors[0].message) : toast.error(error);
      return null;
    }
  };
